var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.div_classes,style:({
    transform: `translate(${_vm.local_text.left}px, ${_vm.local_text.top}px)`,
    color: _vm.local_text.color,
    fontSize: _vm.local_text.size + 'px',
    textAlign: _vm.local_text.align,
    cursor: _vm.isDragging ? 'grabbing' : 'grab'
  }),on:{"mousedown":_vm.start_drag}},[_vm._v(" "+_vm._s(_vm.local_text.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }